<template>
  <div>
    <div class="row">
      <div class="col-md-4 mb-4">
        <info-card
          :title="'Total Arquivado'"
          icon="fas fa-archive"
          variant="warning"
          :value="total_archive.total"
        />
      </div>
    </div>

    <br />
    <br />

    <div class="row grid-table-heading d-md-flex d-none">
      <div class="col-md-6">Descrição</div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-3 text-right">Valor Original</div>
          <div class="col-3 text-right">Saldo Devedor</div>
          <div class="col-3 text-right">Vencimento</div>
          <div class="col-3 text-right">Status</div>
        </div>
      </div>
    </div>
    <hr />
    <table-paginator :data="bills" @pagechange="select($event)">
      <template v-for="row in bills.data">
        <div
          class="row grid-table-row align-items-md-center align-items-start"
          :key="row.id"
        >
          <div class="col-8 col-md-6 d-flex">
            <div>
              <b-dropdown
                variant="transparent"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <i class="fas fa-ellipsis-v text-muted" />
                </template>

                <b-dropdown-item @click.stop="handleRestoreBillReceive(row.id)">
                  <i class="fas fa-redo" /> Restaurar
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <div class="ml-2 mt-1">
              <span>Documento: {{ row.document }}</span>
              <br />
              <small>Arquivado em {{ row.archived_at | dateTimeBr }} </small>
            </div>
          </div>

          <div class="col-4 col-md-6">
            <div class="row">
              <template v-if="row.value > 0">
                <div class="col-md-3 text-right d-none d-md-inline">
                  {{ row.value | decimal }}
                </div>
                <div class="col-md-3 text-right">
                  <b>{{ (row.value - row.received_value) | decimal }}</b>
                </div>
              </template>
              <template v-else>
                <div class="col-md-3 text-right d-none d-md-inline">
                  <span class="text-success">{{
                    (row.value * -1) | decimal
                  }}</span>
                </div>
                <div class="col-md-3 text-right">
                  <span class="text-success">{{
                    ((row.value - row.received_value) * -1) | decimal
                  }}</span>
                </div>
              </template>
              <div class="col-md-3 text-right">
                <template v-if="row.value > 0">
                  <due-date-badge ref="DueDateBadge" :date="row.due_date" />
                </template>
                <template v-else>
                  <h6>
                    <span class="badge badge-success text-white">Crédito</span>
                  </h6>
                </template>
              </div>
              <div class="col-md-3 text-right">
                <span
                  :class="['badge', 'text-white', status[row.status].class]"
                  style="line-height: 1.2"
                  >{{ status[row.status].text }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </template>
    </table-paginator>
  </div>
</template>

<script>
import Filters from "../../../mixins/Filters";
import moment from "moment";
import InfoCard from "../../sections/dashboard/InfoCard.vue";
import DueDateBadge from "../../ui/DueDateBadge.vue";
import TablePaginator from "../../sections/TablePaginator.vue";
import axios from "axios";

export default {
  props: {
    id: {},
  },

  components: {
    InfoCard,

    DueDateBadge,
    TablePaginator,
  },

  data: function () {
    return {
      searchForm: {
        id: null,
        name: null,
        status: "a",
      },

      bills: {},

      total_archive: {},

      status: {
        o: {
          text: "Aberto",
          class: "badge-primary",
        },

        p: {
          text: "Pago",
          class: "badge-success",
        },

        c: {
          text: "Cancelado",
          class: "badge-danger",
        },

        r: {
          text: "Renegociado",
          class: "badge-warning",
        },
        a: {
          text: "Arquivado",
          class: "badge-warning",
        },
      },
    };
  },

  created() {
    //   ;
    // },
    //   created() {
    this.searchForm.id = this.id;
    this.select();

    // this.$store.commit("pageHasLoaded");
    // axios
    // 	.post("api/billreceiveble/selectcancel", this.searchForm)
    // 	.then(response => {
    // 		this.bills = response.data.cancel;
    // 		this.total_archive = response.data.cancelValue;

    // 	})
    // 	.catch(error => {
    // 		this.error = error;
    // 	});
  },

  methods: {
    openBillReceiveCancelForm(bills) {
      this.$refs.billReceivebleCancelForm.open(bills);
    },

    refresh() {
      this.selected = [];
      // todo select current page
      // this.created();
    },

    select(page = 1) {
      this.$store.commit("pageHasLoaded");
      this.searchForm.page = page;

      this.$store
        .dispatch("billreceiveble/getBillsReceivebleArchive", this.searchForm)

        // axios
        //   .get("erp/billReceiveble/bill-receiveble-archive", {
        //     id: this.searchForm.id,
        //     page: page,
        //   })
        .then((response) => {
          this.bills = response.data.bills_archive;
          this.total_archive = response.data.total_archive;
        })
        .catch((error) => {
          this.error = error;
        });
    },
    handleRestoreBillReceive(bill_id) {
      axios
        .put(`/erp/billReceiveble/bill-receiveble-archive/${bill_id}`)
        .then((response) => {
          this.select();
        })
        .catch((error) => {
          this.select();
        });
    },
  },
};
</script>

<style>
</style>
